// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__Ia89L","topBottomGutter":"Layout_topBottomGutter__3c3eN"};